export const questionColor = value => {

  let score = parseInt(value)

  if (score === 1) {
    return '#FF5A5F'
  } else if (score === 2) {
    return '#EB903D'
  } else if (score === 3) {
    return '#24A4DB'
  } else if (score === 4) {
    return '#4DD865'
  } else if (score === 0) {
    return '#5c5a5a'
  }

}